<div style="display: flex; flex-direction: column; height: 100%; overflow: hidden; background-color: white">
  <div class="main-container">
    <p class="saveto">Save to</p>
    <button
      type="button"
      class="close add-close-button"
      style="position: relative; top: 14px; left: -12px"
      data-dismiss="modal"
      (click)="closedialog()"
      >
      <span class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  @if (!isOficeWorkSpace) {
    <div class="radio-button-area">
      @if (isAssetstab) {
        <mat-radio-group style="width: 100%" [(ngModel)]="favoriteSeason" aria-label="Select an option">
          <ng-container>
            @for (item of fulassetList; track item) {
              <div class="radio-box-small-container">
                <div style="width: 100%; display: flex">
                  <div style="width: 100%; margin: 0px 12px; padding: 12px 0px">
                    <img src="assets/images/organization-hierarchy-icon.svg" class="drop-down-icon-image" />
                    {{ item?.name }}
                  </div>
                  @if (item?.estateAssetTabs?.length) {
                    <button
                      style="box-shadow: none"
                      (click)="panel1.toggle(); item.is_open = !item.is_open"
                      mat-raised-button
                      >
                      @if (!item.is_open) {
                        <span class="material-icons"> expand_more </span>
                      }
                      @if (item.is_open) {
                        <span class="material-icons"> expand_less </span>
                      }
                    </button>
                  }
                </div>
                <mat-accordion class="prevent-click">
                  <mat-expansion-panel style="box-shadow: none !important" class="cusotm-panel-body" [expanded]="item.is_open" #panel1>
                    @for (citem of item?.estateAssetTabs; track citem) {
                      <div class="radio-box-small-container">
                        <div style="width: 100%; display: flex" class="folder-title">
                          <div style="width: 100%; margin: 0px 12px 0px 0px; padding: 12px 0px">
                            <img src="assets/images/tab-icon.svg" class="drop-down-icon-image" />
                            {{ citem?.name }}
                          </div>
                          @if (citem?.estateAssetTabGroups?.length) {
                            <button
                              style="box-shadow: none"
                              (click)="panel1.toggle(); citem.is_open = !citem.is_open"
                              mat-raised-button
                              >
                              @if (!citem.is_open) {
                                <span class="material-icons"> expand_more </span>
                              }
                              @if (citem.is_open) {
                                <span class="material-icons"> expand_less </span>
                              }
                            </button>
                          }
                        </div>
                        <mat-accordion class="prevent-click">
                          <mat-expansion-panel style="box-shadow: none !important" [expanded]="citem.is_open" #panel1>
                            @for (scitem of citem?.estateAssetTabGroups; track scitem) {
                              <div class="radio-box-small-container">
                                <div style="width: 100%; display: flex" class="folder-title">
                                  <mat-radio-button [value]="scitem?.id" class="radio-button">
                                    <div class="flex">
                                      <img src="assets/images/subfolder.svg" class="drop-down-icon-image" />
                                      <div class="folder-title">
                                        {{ scitem?.name }}
                                      </div>
                                    </div>
                                  </mat-radio-button>
                                </div>
                              </div>
                            }
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    }
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            }
          </ng-container>
        </mat-radio-group>
      }
      @if (showFolderValueList && !isAssetstab) {
        <div style="width: 100%; padding: 12px" class="body">
          <div>
            @for (item of folderList; track item) {
              <div class="mrb-16px">
                <div class="folder-item-wrapper" (click)="deleteOption($event, item)">
                  <div class="flex fl-al-center" style="width: 85%">
                    <img src="assets/images/white-icon/blu-icons/{{ item.image }}" class="drop-down-icon-image" />
                    <p>{{ item?.name.length > 23 ? item.name.slice(0, 23) + '...' : item.name.slice(0, 23) }}</p>
                  </div>
                  <span class="material-icons subfolders__icon">chevron_right</span>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (!showFolderValueList) {
        <div style="width: 100%; padding: 12px" class="body">
          <div>
            <footer style="margin-bottom: 12px">
              <span
                (click)="moveToPrevious($event, subfolderList)"
                class="material-icons"
                style="font: bolder; position: relative; top: 8px; cursor: pointer"
                >chevron_left</span
                >
              </footer>
              @for (item of subfolderList; track item) {
                <div class="mrb-16px">
                  @if (!item.isGroup) {
                    <div class="folder-item-wrapper" (click)="moveToSub($event, item)">
                      <div class="flex fl-al-center" style="width: 85%">
                        <img style="padding: 7px; background-color: #eee" src="assets/images/subfolder.svg" alt="" />
                        <p>
                          {{ item?.custom_folder_name.length > 20 ? item.custom_folder_name.slice(0, 20) + '...' : item.custom_folder_name.slice(0, 20) }}
                        </p>
                      </div>
                      @if (item?.isChildAvailable || item?.groups?.length) {
                        <span class="material-icons subfolders__icon">chevron_right</span>
                      }
                    </div>
                  }
                  @if (item?.isGroup) {
                    <div class="folder-item-wrapper" (click)="sveGroupId(item.vault_user_folder_id, item)">
                      <div class="flex fl-al-center" style="width: 85%">
                        <img style="padding: 7px; background-color: #eee" src="assets/images/add-group.svg" />
                        <p>
                          {{ item?.name.length > 20 ? item.name.slice(0, 20) + '...' : item.name.slice(0, 20) }}
                        </p>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (isOficeWorkSpace) {
      <div class="radio-button-area">
        @if (showFolderList) {
          <div mat-dialog-content style="padding-left: 0px; width: 100%; margin: 12px" class="body">
            <div class="mrb-16px">
              <div class="folder-item-wrapper" (click)="saveData(workSpaceData.id)">
                <div class="flex fl-al-center">
                  <img style="padding: 7px; background-color: #eee" src="assets/images/workspace-doc-icon.svg" alt="" />
                  <p>
                    {{ workSpaceData?.name?.length > 23 ? workSpaceData?.name?.slice(0, 23) + '...' : workSpaceData?.name?.slice(0, 23) }}
                  </p>
                </div>
                <span (click)="movetoFolderlist()" class="material-icons">chevron_right</span>
              </div>
            </div>
          </div>
        }
        @if (subfolderList && subfolderList.length && !showFolderList) {
          <div
            mat-dialog-content
            style="padding-left: 0px; width: 100%; margin: 12px"
            class="body"
            >
            <div (click)="MovetoParent(subfolderList)" class="mrb-16px material-icons">chevron_left</div>
            @for (item of subfolderList; track item) {
              <div class="mrb-16px">
                <div class="folder-item-wrapper">
                  <div class="flex fl-al-center" (click)="saveData(item.id)">
                    <img style="padding: 7px; background-color: #eee" src="assets/images/workspace-doc-icon.svg" alt="" />
                    <p>
                      {{ item?.name?.length > 23 ? item?.name?.slice(0, 23) + '...' : item?.name?.slice(0, 23) }}
                    </p>
                  </div>
                  @if (item.isChildAvailable) {
                    <span (click)="MovetoChild(item)" class="material-icons">chevron_right</span>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (!hideSaveBtn) {
      <div class="fooret">
        <button [class.disable-button-continue]="!favoriteSeason" (click)="save()" class="save-continue-button">Save</button>
      </div>
    }
  </div>
